<template>
    <div class="contract-type">
        <ul>
            <li v-for="(item, index) in contractList" :key="index" @click="select = index, setLink()">
                <img v-if="select == index" class="radio-img" src="@/assets/img/icon/radio_green.svg" alt="">
                <img v-else class="radio-img" src="@/assets/img/icon/radio_gray.svg" alt="">
                <div class="contrat-content">
                    <div class="title">
                        {{item.title}}
                    </div>
                    <div class="description">
                        {{item.description}}
                    </div>
                </div>
            </li>
        </ul>
    </div>
</template>
<script>
export default {
    data () {
        return {
            select: 0,
            contractList: [
                // {
                //     title: '全新合約，空房有新租客',
                //     description: '我是敘述 我是敘述 我是敘述 我是敘述 我是敘述 我是敘述 我是敘述 我是敘述 我是敘述 我是敘述 我是敘述'
                // },
                {
                    title: '已有紙本合約',
                    description: '此情境用於您現在與租客已經有紙本租約，將線下收租模式改成線上收租。'
                }
            ]
        }
    },
    mounted() {
        this.$emit('getLink', 'bizNewPaperContract');
    },
    methods: {
        setLink: function () {
            // if( this.select == 0 ){
            //     this.$emit('getLink', '123');
            // }else{
                this.$emit('getLink', 'bizNewPaperContract');
            // }
        }
    }
}
</script>
<style lang="scss"  >
    .contract-type{
        position: relative;
        height: 182px;
        margin-bottom: 60px;
        ul{
            li{
                position: relative;
                display: flex;
                align-items: flex-start;
                margin-bottom: 30px;
                cursor: pointer;
                .radio-img{
                    margin-right: 12px;
                }
                .contrat-content{
                    width: 400px;
                    .title{
                        margin-bottom: 12px;
                        font-size: 16px;
                        font-weight: 500;
                    }
                    .description{
                        font-weight: 300;
                        line-height: 1.57;
                    }
                }
            }
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/bussiness/widges/tools/ContractType.vue